module.exports = __webpack_public_path__ + "img/clipboard-check.ed27255b.svg";